export default __webpack_public_path__ + "static/media/cluster-zoom-in.43f66a51.svg";